import {
  Calculator,
  CalendarDays,
  House,
  UserRound,
  Settings,
  Clock,
  ChartNoAxesCombined,
  WashingMachine,
  Calendar,
} from "lucide-react";

export const adminLinks = [
  {
    label: "Dashboard",
    path: "/adminDashboard",
    icon: House,
  },
  {
    label: "Organization",
    path: "/organization",
    icon: Settings,
  },
  {
    label: "Employees",
    path: "/employees",
    icon: UserRound,
  },
  {
    label: "Attendance",
    path: "/attendance",
    icon: Clock,
  },
  {
    label: "Leave",
    path: "/leave",
    icon: CalendarDays,
  },
  {
    label: "Payroll",
    path: "/payroll",
    icon: Calculator,
  },
  {
    label: "Calendar",
    path: "/calendar",
    icon: Calendar,
  },
  // {
  //   label: "Reports",
  //   path: "/reports",
  //   icon: ChartNoAxesCombined,
  // },
  // {
  //   label: "Others",
  //   path: "/other",
  //   icon: WashingMachine,
  // },
];
export const customLinks = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: House,
  },
  {
    label: "Organization",
    path: "/organization",
    icon: Settings,
  },
  {
    label: "Employees",
    path: "/employees",
    icon: UserRound,
  },
  {
    label: "Attendance",
    path: "/attendance",
    icon: Clock,
  },
  {
    label: "Leave",
    path: "/leave",
    icon: CalendarDays,
  },
  {
    label: "Payroll",
    path: "/payroll",
    icon: Calculator,
  }
];
export const employeeLinks = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: House,
  },
  {
    label: "Employees",
    path: "/employees",
    icon: UserRound,
  },
  {
    label: "Attendance",
    path: "/attendance",
    icon: Clock,
  },
  {
    label: "Leave",
    path: "/leave",
    icon: CalendarDays,
  }
];